// components/features/clients/ClientRow.tsx

import { Client } from "../../../types/features/Client";
import TableRow from "../../ui/TableRow";

interface ClientRowProps {
  client: Client;
  onAction: (client: Client) => void;
  onSelect?: (client: Client, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function ClientRow({
  client,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false
}: ClientRowProps) {
  const firstname = client.firstname?.trim();
  const lastname = client.lastname?.trim();
  
  // Nom complet ou statut "Nouveau client"
  const fullName = (firstname || lastname) 
    ? `${firstname ?? ''} ${lastname ?? ''}`.trim() 
    : "Nouveau client";

  // Email ou statut "Nouveau client"
  const emailText = client.email ?? "Nouveau client";

  // Initiales ou icône "?"
  const initials = (firstname || lastname)
    ? `${firstname?.charAt(0) ?? ''}${lastname?.charAt(0) ?? ''}`.toUpperCase()
    : "?";

  return (
    <TableRow
      item={client}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {/* Colonne Contact : Avatar + Nom + Email */}
      <td className="py-3 px-4">
        <div className="flex items-center space-x-3">
          {/* Avatar JustCall style */}
          <div className={`h-9 w-9 rounded-full flex items-center justify-center font-semibold text-xs shrink-0 border ${
            fullName === "Nouveau client"
              ? "bg-amber-50 text-amber-700 border-amber-200"
              : "bg-indigo-100 text-indigo-700 border-indigo-200"
          }`}>
            {initials}
          </div>

          {/* Informations Nom & Email */}
          <div className="min-w-0 flex-1">
            <div className="flex items-center space-x-2">
              <span className={`text-sm block truncate ${
                fullName === "Nouveau client" 
                  ? "font-semibold text-amber-600" 
                  : "font-medium text-gray-900"
              }`}>
                {fullName}
              </span>
              
              {fullName === "Nouveau client" && (
                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-800">
                  Nouveau
                </span>
              )}
            </div>

            <span className={`text-xs block truncate max-w-[200px] sm:max-w-[300px] ${
              emailText === "Nouveau client" ? "text-amber-500 italic" : "text-gray-500"
            }`}>
              {emailText}
            </span>
          </div>
        </div>
      </td>

      {/* Colonne Téléphone */}
      <td className="hidden sm:table-cell py-3 px-4 whitespace-nowrap">
        <span className="text-gray-700 text-sm font-medium">
          {client.phone ?? "Nouveau client"}
        </span>
      </td>

      {/* Colonne Date de création */}
      <td className="hidden md:table-cell py-3 px-4 whitespace-nowrap">
        <span className="text-gray-500 text-xs">
          {client.created_at
            ? new Date(client.created_at).toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
              })
            : "—"}
        </span>
      </td>
    </TableRow>
  );
}